module.exports = __webpack_public_path__ + "img/report-2.785add42.jpg";